// CCC-001 CC-S1 anti-regressão — script de landing.html externo (CSP sem unsafe-inline).
//
// Calvin 2026-09-28: "ecbyts.com deve sempre aparecer para o usuário com o idioma
// configurado no navegador dele".
//
// COMO FUNCIONA (script CLÁSSICO de propósito — roda sem o grafo de módulos):
//   1. decide o idioma: escolha salva (`ecbyts_lang` do app ou `ecbyts-language`,
//      a chave declarada no aviso de privacidade) → senão `navigator.languages`,
//      com alias de código curto ('pt'→pt-BR) e prefixo de 2 letras (fr-CA→fr-FR);
//   2. baixa SÓ os ~4 KB de `./assets/i18n/landing/<locale>.json` (o corpus do app
//      tem ~1 MB por idioma — carregá-lo numa página de marketing seria regressão);
//   3. aplica em `[data-i18n]` (textContent) e `[data-i18n-html]` (titleHtml);
//   4. atualiza <html lang> e dir (ar-SA é RTL) e o seletor de idiomas;
//   5. persiste a escolha manual em `ecbyts_lang` E `ecbyts-language` — as duas,
//      porque o app lê a primeira e o resto da casa (STT/TTS, boot, LGPD) lê a segunda.
//
// FALLBACK: o HTML já vem com o texto em português (mercado principal) e o valor de
// cada chave; se o JSON não carregar, a página continua legível e clicável — nunca
// fica em branco nem mostra identificador de chave.
(function () {
    'use strict';

    var SUPPORTED = [
        'pt-BR',
        'en-US',
        'es-LA',
        'zh-CN',
        'fr-FR',
        'de-DE',
        'ja-JP',
        'it-IT',
        'ko-KR',
        'ru-RU',
        'id-ID',
        'hi-IN',
        'tr-TR',
        'pl-PL',
        'sv-SE',
        'ar-SA',
    ];
    var BASE = 'pt-BR';
    var STORAGE_KEY = 'ecbyts_lang';
    var PUBLIC_STORAGE_KEY = 'ecbyts-language';
    var ALIAS = { en: 'en-US', pt: 'pt-BR', es: 'es-LA' };
    var RTL = ['ar-SA'];
    var ASSET_PATH = './assets/i18n/landing/';
    var localeRequest = 0;
    var appliedLocale = BASE;

    function resolveLocale(code) {
        if (!code) return BASE;
        var resolved = Object.prototype.hasOwnProperty.call(ALIAS, code) ? ALIAS[code] : code;
        return SUPPORTED.indexOf(resolved) >= 0 ? resolved : BASE;
    }

    // Mesma regra de `detectLanguage` em app/js/boot/i18n-early.js e de
    // `resolveInitialLegalLocale` em src/app/js/utils/i18n/legalPageRenderer.ts.
    function detectLanguage(storage, nav) {
        var saved = '';
        try {
            saved = (storage && (storage.getItem(STORAGE_KEY) || storage.getItem(PUBLIC_STORAGE_KEY))) || '';
        } catch (e) {
            saved = '';
        }
        if (saved && SUPPORTED.indexOf(saved) >= 0) return saved;

        var candidates =
            nav && nav.languages && nav.languages.length ? nav.languages : nav && nav.language ? [nav.language] : [];
        for (var i = 0; i < candidates.length; i++) {
            var cand = String(candidates[i] || '').trim();
            if (!cand) continue;
            var lower = cand.toLowerCase();
            var aliased = Object.prototype.hasOwnProperty.call(ALIAS, lower) ? ALIAS[lower] : cand;
            if (SUPPORTED.indexOf(aliased) >= 0) return aliased;
            var prefix = lower.slice(0, 2);
            for (var j = 0; j < SUPPORTED.length; j++) {
                if (SUPPORTED[j].toLowerCase().indexOf(prefix) === 0) return SUPPORTED[j];
            }
        }
        // Navegador sem casamento (ex.: holandês): inglês é a reserva internacional.
        return 'en-US';
    }

    function apply(dict, lang) {
        // lang/dir valem mesmo sem dicionário: o texto cai na base (português),
        // e a página precisa declarar o idioma que está REALMENTE exibindo.
        document.documentElement.lang = lang;
        document.documentElement.dir = RTL.indexOf(lang) >= 0 ? 'rtl' : 'ltr';
        if (!dict) return;
        var nodes = document.querySelectorAll('[data-i18n]');
        for (var i = 0; i < nodes.length; i++) {
            var key = nodes[i].getAttribute('data-i18n');
            var value = dict[key];
            // GUARDA OBRIGATÓRIA: chave ausente no dicionário NÃO pode virar a palavra
            // "undefined" na tela. Regressão medida em 2026-09-30: esta linha foi perdida ao
            // acrescentar o tratamento de `<meta>` abaixo, e como outras páginas (cursos)
            // passaram a carregar este boot, TODA chave `bi.*`/`excel.*`/`shared.*` delas —
            // que não existe no dicionário da landing — saía escrita como "undefined".
            if (typeof value !== 'string' || !value) continue;
            // `<meta>` nao tem texto: a descricao que aparece na busca e na previa de link
            // vive no atributo `content` — textContent ali nao faria nada e a pagina
            // continuaria em portugues no resultado do Google (provado nas paginas de curso).
            if (nodes[i].tagName === 'META') {
                nodes[i].setAttribute('content', value);
            } else {
                nodes[i].textContent = value;
            }
        }
        var htmlNodes = document.querySelectorAll('[data-i18n-html]');
        for (var k = 0; k < htmlNodes.length; k++) {
            var htmlKey = htmlNodes[k].getAttribute('data-i18n-html');
            var htmlValue = dict[htmlKey];
            // Só o destaque do título usa HTML; a montagem é feita pelo gerador de
            // tradução (o tradutor nunca vê tags). Ver tests/public-pages-browser-locale.
            if (typeof htmlValue === 'string' && htmlValue) htmlNodes[k].innerHTML = htmlValue;
        }
        var video = document.getElementById('product-video');
        if (video && dict['product.video.title']) video.setAttribute('aria-label', dict['product.video.title']);
        renderPlanPrices();
    }

    function load(lang) {
        if (typeof fetch !== 'function') return Promise.resolve(null);
        return fetch(ASSET_PATH + lang + '.json')
            .then(function (r) {
                return r && r.ok ? r.json() : null;
            })
            .catch(function () {
                return null;
            });
    }

    function persist(lang) {
        try {
            localStorage.setItem(STORAGE_KEY, lang);
            localStorage.setItem(PUBLIC_STORAGE_KEY, lang);
        } catch (e) {
            console.debug('[boot:lang-storage]', e && e.message ? e.message : e);
        }
    }

    function setLang(lang, persistChoice, selector) {
        var resolved = SUPPORTED.indexOf(lang) >= 0 ? lang : BASE;
        var request = ++localeRequest;
        var pageI18n = window.__ecbytsStaticPageI18n;
        // Nas páginas de cursos, corpo e navegação mudam juntos. Nenhum deles
        // declara o idioma novo antes de os dois dicionários estarem disponíveis.
        var content = pageI18n ? pageI18n.prepareLocale(resolved) : Promise.resolve(true);
        return Promise.all([load(resolved), content]).then(function (dictionaries) {
            if (request !== localeRequest) return appliedLocale;
            var dict = dictionaries[0];
            if (!dict || !dictionaries[1]) {
                if (selector) selector.value = appliedLocale;
                apply(null, appliedLocale);
                // JavaScript ativo com falha de rede não entra em <noscript>.
                // O primeiro catálogo precisa de erro visível e retry do idioma.
                if (!catalogLabels) {
                    var catalogFailure = document.querySelector('[data-catalog-error]');
                    if (catalogFailure) catalogFailure.hidden = false;
                }
                return appliedLocale;
            }
            if (pageI18n) pageI18n.applyLocale(dictionaries[1], resolved);
            apply(dict, resolved);
            appliedLocale = resolved;
            renderProductCatalog(dict, resolved);
            if (selector) selector.value = resolved;
            if (persistChoice) persist(resolved);
            return resolved;
        });
    }

    var storage = null;
    try {
        storage = window.localStorage;
    } catch (e) {
        storage = null;
    }
    var selector = document.getElementById('landing-lang');
    var detected = detectLanguage(storage, typeof navigator !== 'undefined' ? navigator : null);

    if (selector) {
        selector.value = detected;
        var label = document.querySelector('[data-i18n="landing.lang.label"]');
        if (label) label.setAttribute('aria-label', label.textContent || 'Language');
        selector.addEventListener('change', function () {
            setLang(selector.value, true, selector);
        });
    }

    // Primeira pintura com o idioma do navegador: NÃO persiste (só a escolha
    // explícita do usuário vira preferência — senão o idioma do navegador ficaria
    // congelado para sempre na primeira visita).
    setLang(detected, false, selector);

    // Exposto para o teste executar a MESMA decisão que o navegador roda.
    window.__ecbytsLandingLang = {
        detectLanguage: detectLanguage,
        setLang: setLang,
        supported: SUPPORTED,
        base: BASE,
    };

    // O MP4 só é solicitado depois do gesto: a primeira visita baixa apenas a capa.
    var playButton = document.querySelector('[data-product-play]');
    var productVideo = document.getElementById('product-video');
    var videoLink = document.querySelector('[data-product-video-link]');
    var videoPoster = document.querySelector('[data-product-poster]');
    var videoError = document.querySelector('[data-product-error]');
    if (playButton && productVideo && videoLink) {
        var showVideoError = function () {
            playButton.hidden = false;
            if (videoError) videoError.hidden = false;
        };
        productVideo.addEventListener('error', showVideoError);
        playButton.addEventListener('click', function () {
            if (videoError) videoError.hidden = true;
            if (videoPoster) videoPoster.hidden = true;
            productVideo.hidden = false;
            playButton.hidden = true;
            if (!productVideo.getAttribute('src')) productVideo.src = videoLink.href;
            else if (productVideo.error) productVideo.load();
            productVideo.focus();
            var playing = productVideo.play();
            if (playing && typeof playing.catch === 'function') playing.catch(showVideoError);
        });
    }

    // Mesma fonte da cobrança; nenhuma cópia de preço em HTML/dicionário.
    // Este módulo é puro e pequeno: não inicializa o aplicativo nem o motor 3D.
    var planPrices = null;
    function renderPlanPrices() {
        if (!planPrices) return;
        var formatter = new Intl.NumberFormat(document.documentElement.lang || BASE, {
            style: 'currency',
            currency: planPrices.currency,
        });
        var nodes = document.querySelectorAll('[data-plan-price]');
        for (var i = 0; i < nodes.length; i++) {
            nodes[i].textContent = formatter.format(planPrices[nodes[i].getAttribute('data-plan-price')]);
        }
    }
    if (document.querySelector('[data-plan-price]')) {
        import('../core/billing/proPlanPrice.js')
            .then(function (module) {
                var prices = module.PRO_PLAN_PRICE;
                if (
                    !prices ||
                    prices.status !== 'aprovado' ||
                    prices.currency !== 'BRL' ||
                    !Number.isFinite(prices.monthly) ||
                    prices.monthly <= 0 ||
                    !Number.isFinite(prices.yearly) ||
                    prices.yearly <= 0
                ) {
                    throw new Error('public-plan-price-unavailable');
                }
                planPrices = prices;
                renderPlanPrices();
            })
            .catch(function () {
                // O HTML já traz o preço aprovado; o aviso só aparece se não houver valor.
                var empty = Array.prototype.some.call(document.querySelectorAll('[data-plan-price]'), function (node) {
                    return !/\d/.test(node.textContent || '');
                });
                var warning = document.querySelector('[data-price-error]');
                if (warning && empty) warning.hidden = false;
            });
    }

    var catalogManifest = null;
    var catalogRequest = 0;
    var catalogLabels = null;
    var catalogLocale = BASE;
    function getProductCatalog() {
        if (!catalogManifest) {
            catalogManifest = fetch('./assets/public-products.json')
                .then(function (response) {
                    if (!response.ok) throw new Error('product-catalog-unavailable');
                    return response.json();
                })
                .then(function (manifest) {
                    if (manifest.schemaVersion !== 1 || !Array.isArray(manifest.items))
                        throw new Error('product-catalog-invalid');
                    return manifest.items.filter(function (item) {
                        if (item.published !== true) return false;
                        if (
                            !item.id ||
                            !['course', 'plan', 'product'].includes(item.category) ||
                            !/^\.\/[a-z0-9-]+\.html(?:#[a-z0-9-]+)?$/.test(item.href) ||
                            typeof item.titleKey !== 'string' ||
                            typeof item.descriptionKey !== 'string'
                        ) {
                            throw new Error('product-catalog-invalid');
                        }
                        return true;
                    });
                })
                .catch(function (error) {
                    catalogManifest = null;
                    throw error;
                });
        }
        return catalogManifest;
    }
    function renderProductCatalog(labels, lang) {
        var host = document.querySelector('[data-product-catalog]');
        if (!host) return;
        catalogLabels = labels;
        catalogLocale = lang;
        var request = ++catalogRequest;
        var failure = document.querySelector('[data-catalog-error]');
        host.replaceChildren();
        host.setAttribute('aria-busy', 'true');
        if (failure) failure.hidden = true;
        Promise.all([
            getProductCatalog(),
            fetch('./assets/i18n/static/' + lang + '.json').then(function (response) {
                if (!response.ok) throw new Error('product-labels-unavailable');
                return response.json();
            }),
        ])
            .then(function (results) {
                if (request !== catalogRequest) return;
                var copy = Object.assign({}, results[1], labels);
                var fragment = document.createDocumentFragment();
                results[0].forEach(function (item) {
                    if (!copy[item.titleKey] || !copy[item.descriptionKey])
                        throw new Error('product-labels-incomplete');
                    var card = document.createElement('a');
                    card.className = 'product-card product-card-link';
                    card.href = item.href;
                    card.setAttribute('data-product-id', item.id);
                    var kind = document.createElement('p');
                    kind.className = 'product-kicker';
                    kind.textContent = copy['product.catalog.' + item.category];
                    var title = document.createElement('h3');
                    title.textContent = copy[item.titleKey];
                    var description = document.createElement('p');
                    description.textContent = copy[item.descriptionKey];
                    var link = document.createElement('span');
                    link.className = 'product-button';
                    link.textContent = copy['product.catalog.open'];
                    card.setAttribute('aria-label', link.textContent + ': ' + title.textContent);
                    card.append(kind, title, description, link);
                    fragment.appendChild(card);
                });
                if (!results[0].length) {
                    var empty = document.createElement('p');
                    empty.textContent = copy['product.catalog.empty'];
                    fragment.appendChild(empty);
                }
                host.replaceChildren(fragment);
                host.removeAttribute('aria-busy');
            })
            .catch(function () {
                if (request !== catalogRequest) return;
                host.removeAttribute('aria-busy');
                if (failure) failure.hidden = false;
            });
    }
    var retryCatalog = document.querySelector('[data-catalog-retry]');
    if (retryCatalog)
        retryCatalog.addEventListener('click', function () {
            if (catalogLabels) renderProductCatalog(catalogLabels, catalogLocale);
            else setLang(appliedLocale, false, selector);
        });
})();

// pricing.html — os itens densos (saldo, selo, IA, registros) ficam dentro de <details>
// para a pagina continuar escaneavel. Um link direto (#selo-ecbyts, #ia-ecbyts, ...) nao
// pode cair em bloco fechado: abre o <details> que contem o alvo. CSP de producao nao
// permite script inline (script-src sem unsafe-inline), por isso vive neste arquivo.
(function () {
    if (!document.querySelector('details.product-lean')) return;
    function abrirBlocoDoAlvo() {
        var hash = window.location.hash;
        if (!hash || hash.length < 2) return;
        var alvo = null;
        try {
            alvo = document.getElementById(decodeURIComponent(hash.slice(1)));
        } catch (error) {
            return;
        }
        if (!alvo || typeof alvo.closest !== 'function') return;
        var bloco = alvo.closest('details.product-lean');
        if (bloco && !bloco.open) bloco.open = true;
    }
    abrirBlocoDoAlvo();
    window.addEventListener('hashchange', abrirBlocoDoAlvo, { passive: true });
})();
